export const ORDER_STATUS = {
  DRAFT: 'draft',
  RESOLVING: 'resolving',
  RESOLUTION_FAILED: 'resolution_failed',
  REVIEW: 'review',
  // Transient lock while the credit debit is in flight (DS REVIEW→PAYING→PAID).
  // The member normally never sees it — pay() returns the PAID order — but an
  // interrupted pay resumes here and the wizard polls it to completion.
  PAYING: 'paying',
  PAID: 'paid',
  ACCEPTED: 'accepted',
  IN_PRODUCTION: 'in_production',
  SHIPPED: 'shipped',
  CANCELLED: 'cancelled',
};

export const WIZARD_STEP = {
  ASSET: 'asset',
  AUDIENCE: 'audience',
  RESOLUTION: 'resolution',
  REVIEW: 'review',
  PAY: 'pay',
  CONFIRMATION: 'confirmation',
};

export const AUDIENCE_MODE = {
  ALL: 'all',
  TAGS: 'tags',
};

export const RESOLUTION_POLL_INTERVAL_MS = 2500;
export const AUDIENCE_PREVIEW_DEBOUNCE_MS = 500;
export const CREDITS_HISTORY_PAGE_SIZE = 10;
// A resumed PAYING order is polled this many times (~15s) before the wizard
// stops and surfaces a recovery action, so a stuck debit can never strand the
// member on a dead screen.
export const MAX_PAYING_POLLS = 6;

// Statuses where the member can resume the order in the wizard
export const RESUMABLE_STATUSES = [
  ORDER_STATUS.DRAFT,
  ORDER_STATUS.RESOLVING,
  ORDER_STATUS.RESOLUTION_FAILED,
  ORDER_STATUS.REVIEW,
  // An interrupted pay: the wizard resumes at Pay and polls PAYING→PAID/REVIEW.
  ORDER_STATUS.PAYING,
];

// Statuses where the member is allowed to cancel the order
export const CANCELLABLE_STATUSES = [ORDER_STATUS.REVIEW, ORDER_STATUS.PAID];

export const STATUS_CHIP_CLASSES = {
  [ORDER_STATUS.DRAFT]: 'bg-neutral-100 text-neutral-800',
  [ORDER_STATUS.RESOLVING]: 'bg-blue-100 text-blue-800',
  [ORDER_STATUS.RESOLUTION_FAILED]: 'bg-error-50 text-error-500',
  [ORDER_STATUS.REVIEW]: 'bg-amber-100 text-amber-800',
  [ORDER_STATUS.PAYING]: 'bg-blue-100 text-blue-800',
  [ORDER_STATUS.PAID]: 'bg-green-100 text-green-800',
  [ORDER_STATUS.ACCEPTED]: 'bg-green-100 text-green-800',
  [ORDER_STATUS.IN_PRODUCTION]: 'bg-blue-100 text-blue-800',
  [ORDER_STATUS.SHIPPED]: 'bg-green-100 text-green-800',
  [ORDER_STATUS.CANCELLED]: 'bg-neutral-200 text-neutral-500',
};
